<template>
  <div class="status column" :class="issue.status">
    <v-icon v-if="issue.status === issueStatuses.FIXED">check</v-icon>
    <span class="status-name">{{$t(calculatedStatusName)}}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { ISSUE_STATUSES } from '@/constants/issues';
import { getIssueStatusNameAccordingToUserRoleGroup } from '@/utils/issueUtils';

export default {
  name: 'IssueStatus',
  props: {
    issue: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['userRoleGroup']),
    issueStatuses() {
      return ISSUE_STATUSES;
    },
    calculatedStatusName() {
      return getIssueStatusNameAccordingToUserRoleGroup(this.userRoleGroup, this.issue.status);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.status {
  text-transform: capitalize;
  display: inline-block;
  font-size: $font-size-base;
  letter-spacing: 0;
  line-height: rem(16);
  text-align: right;

  &.found {
    color: var(--text-primary);
  }
  &.fixed {
    color: $severity-low;
  }

  .v-icon {
    color: $severity-low;
    display: inline;
    font-size: $font-size-sm;
  }
}
</style>
